// extracted by mini-css-extract-plugin
export var cardLayout = "_8c-1";
export var paginationContainer = "_8c-0";